module.exports = __webpack_public_path__ + "media/诺手MV.0d8ea414.mp4";